import en from './locales/en.json';
import ru from './locales/ru.json';
import uk from './locales/uk.json';
import { useLanguage } from '../contexts/LanguageContext';
import {useCallback, useMemo} from "react";

// Все переводы
const translations = {
  en,
  ru,
  uk,
};

function translate(lang, key, params = {}) {
  const keys = key.split('.');
  let translation = translations[lang];

  for (const k of keys) {
    if (translation && translation[k] !== undefined) {
      translation = translation[k];
    } else {
      translation = undefined;
      break;
    }
  }

  if (translation === undefined) {
    let fallback = translations.en;
    for (const k of keys) {
      if (fallback && fallback[k] !== undefined) {
        fallback = fallback[k];
      } else {
        fallback = key;
        break;
      }
    }
    translation = fallback;
  }

  if (typeof translation === 'string') {
    Object.keys(params).forEach(param => {
      translation = translation.replace(`{${param}}`, params[param]);
    });
  }

  return translation;
}

// Для вызова вне React-дерева (не в компоненте) — берёт язык напрямую из localStorage.
// Внутри компонентов используй useTranslation(), не эту функцию — она не реактивна.
export function t(key, params = {}) {
  const lang = localStorage.getItem('preferred_language') || 'en';
  return translate(lang, key, params);
}

// Хук useTranslation — единый источник языка: LanguageContext.
// Любой компонент, вызвавший useTranslation(), автоматически перерисуется
// при смене языка где угодно в приложении — React сам это обеспечивает
// через контекст, без localStorage-событий и ручных forceUpdate.
export function useTranslation() {
  const { language, changeLanguage } = useLanguage();

  const translateBound = useCallback(
    (key, params = {}) => translate(language, key, params),
    [language]
  );

  return useMemo(
    () => ({ t: translateBound, language, changeLanguage }),
    [translateBound, language, changeLanguage]
  );
}

export { translations };
export default translations;